import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { HelpdeskDtoKeyEnum } from '@zaoblako/shared/modules/helpdesk/enum/helpdesk-dto-key.enum';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import { entityLikeSchema } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import { EavEntityFormDto, type EavEntityFormInterface } from '@zaoblako/shared/modules/eav/dtos/entity/eav-entity-form.dto';
import type { OnlyIdRequiredInterface } from '@zaoblako/shared/common/interfaces/only-id-required.interface';
import type { HelpdeskTaskTypeFindInterface } from '@zaoblako/shared/modules/helpdesk/dto/task-type/helpdesk-task-type-find.dto';
import type { ExternalUserFindInterface } from '@zaoblako/shared/modules/security/dtos/external-user/external-user-find.dto';

import * as yup from 'yup';

/** Helpdesk task for personal account create and update APIs request body */
export interface HelpdeskTaskPersonalAccountFormInterface {
  /** Task description */
  description: string;
  /** Task type */
  taskType: OnlyIdRequiredInterface<HelpdeskTaskTypeFindInterface>;
  /** External user auditors */
  externalUserAuditors?: OnlyIdRequiredInterface<ExternalUserFindInterface>[];
  /** Additional EAV fields (personal-account types only) */
  eavEntity?: EavEntityFormInterface;
}

/** Helpdesk task for personal account create and update APIs request body - DTO schema */
export const HelpdeskTaskPersonalAccountFormDto = SerdeDtoClass.create<HelpdeskTaskPersonalAccountFormInterface>(
  HelpdeskDtoKeyEnum.HELPDESK_TASK_PERSONAL_ACCOUNT_FORM_DTO,
  {
    description: {
      label: 'Описание',
      serializer: yup
        .string()
        .min(1, DtoMessageEnum.EMPTY_STRING),
    },
    taskType: {
      label: 'Тип заявки',
      serializer: entityLikeSchema,
    },
    externalUserAuditors: {
      optional: true,
      label: 'Внешние аудиторы',
      serializer: yup.array(entityLikeSchema),
    },
    eavEntity: {
      optional: true,
      label: 'Дополнительные реквизиты',
      nested: EavEntityFormDto,
      serializer: (_, nested) => nested,
    },
  },
);
